import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "panel"]
  static values = {
    selected: String,
    default: String
  }

  connect() {
    this.handlePopState = this.handlePopState.bind(this)
    window.addEventListener("popstate", this.handlePopState)
    this.activate(this.selectedValue || this.defaultValue)
  }

  disconnect() {
    window.removeEventListener("popstate", this.handlePopState)
  }

  select(event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return

    const option = event.currentTarget
    const variantId = option.dataset.variantId
    if (!this.activate(variantId)) return

    event.preventDefault()
    window.history.pushState({ variantId }, "", option.dataset.variantUrl || option.href)
  }

  handlePopState() {
    const variantId = new URL(window.location.href).searchParams.get("variant") || this.defaultValue
    this.activate(variantId)
  }

  activate(variantId) {
    const normalizedId = String(variantId || "")
    const selectedOption = this.optionTargets.find((option) => option.dataset.variantId === normalizedId)
    if (this.hasOptionTarget && !selectedOption) return false

    this.optionTargets.forEach((option) => {
      option.setAttribute("aria-current", String(option.dataset.variantId === normalizedId))
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.variantId !== normalizedId
    })

    this.selectedValue = normalizedId
    return true
  }
}
